import {
    Box,
    Button,
    Typography,
    TextField,
    TextareaAutosize,
    Paper,
    Link,
} from '@material-ui/core';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import useSessionStore from '@services/stores/SessionStore'
import { useStyles } from '@pages/account/wishlists/create/index';
import { useTranslation } from '@tools/i18n';

export default function WeddingWishlistConfigurator({ currentSelected, onChange, onDateChange, onContinue, step }) {
    const classes = useStyles();
    const config = useSessionStore((state) => state.session.config);
    const { t } = useTranslation(['account']);

    return (
        <Box className={classes.wrapper}>
            {step === 1 && (
                <>
                    <Typography
                        variant="h6"
                        className={classes.title}
                        dangerouslySetInnerHTML={{ __html: t('wishlist-wizard-wedding-intro-title')}}>
                    </Typography>
                    <div className={classes.halfWidthWrapper}>
                        <div className={classes.halfWidth}>
                            <TextField
                                fullWidth
                                label={t('wishlist-wizard-wedding-firstname')}
                                value={currentSelected?.meta?.person1?.firstName || ''}
                                onChange={e =>
                                    onChange({
                                        ...currentSelected,
                                        meta: {
                                            ...currentSelected?.meta,
                                            person1: {
                                                ...currentSelected?.meta?.person1,
                                                firstName: e.currentTarget.value,
                                            },
                                        },
                                    })
                                }
                                variant="outlined"
                                margin="normal"
                                className={classes.input}
                                placeholder={'Mick'}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                        <div className={classes.halfWidth}>
                            <TextField
                                fullWidth
                                label={t('wishlist-wizard-wedding-lastname')}
                                value={currentSelected?.meta?.person1?.lastName  || ''}
                                onChange={e =>
                                    onChange({
                                        ...currentSelected,
                                        meta: {
                                            ...currentSelected?.meta,
                                            person1: {
                                                ...currentSelected?.meta?.person1,
                                                lastName: e.currentTarget.value,
                                            },
                                        },
                                    })
                                }
                                variant="outlined"
                                margin="normal"
                                className={classes.input}
                                placeholder={'Jagger'}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                    </div>

                    <Button
                        disabled={
                            !(currentSelected?.meta?.person1?.firstName && currentSelected?.meta?.person1?.lastName)
                        }
                        fullWidth
                        className={classes.continueButton}
                        onClick={onContinue}
                    >
                        {t('wishlist-wizard-wedding-next-step')}
                    </Button>
                </>
            )}
            {step === 2 && (
                <>
                    <Typography variant="h6" className={classes.title}>
                        {t('wishlist-wizard-wedding-intro-second-name')}
                    </Typography>
                    <div className={classes.halfWidthWrapper}>
                        <div className={classes.halfWidth}>
                            <TextField
                                fullWidth
                                label={t('wishlist-wizard-wedding-firstname')}
                                value={currentSelected?.meta?.person2?.firstName  || ''}
                                onChange={e =>
                                    onChange({
                                        ...currentSelected,
                                        meta: {
                                            ...currentSelected?.meta,
                                            person2: {
                                                ...currentSelected?.meta?.person2,
                                                firstName: e.currentTarget.value,
                                            },
                                        },
                                    })
                                }
                                variant="outlined"
                                margin="normal"
                                className={classes.input}
                                placeholder={'Bianca'}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                        <div className={classes.halfWidth}>
                            <TextField
                                fullWidth
                                label={t('wishlist-wizard-wedding-lastname')}
                                value={currentSelected?.meta?.person2?.lastName  || ''}
                                onChange={e =>
                                    onChange({
                                        ...currentSelected,
                                        meta: {
                                            ...currentSelected?.meta,
                                            person2: {
                                                ...currentSelected?.meta?.person2,
                                                lastName: e.currentTarget.value,
                                            },
                                        },
                                    })
                                }
                                variant="outlined"
                                margin="normal"
                                className={classes.input}
                                placeholder={'Pérez-Mora Macías'}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                    </div>

                    <Button
                        disabled={
                            !(currentSelected?.meta?.person2?.firstName && currentSelected?.meta?.person2?.lastName)
                        }
                        fullWidth
                        className={classes.continueButton}
                        onClick={onContinue}
                    >
                        {t('wishlist-wizard-wedding-next-step')}
                    </Button>
                </>
            )}
            {step === 3 && (
                <>
                    <Typography variant="h6" className={classes.title}>
                        När ska ni gifta er och på vilken plats?
                    </Typography>

                    <TextField
                        fullWidth
                        label="Plats"
                        value={currentSelected?.location}
                        onChange={e => onChange({ ...currentSelected, location: e.currentTarget.value })}
                        variant="outlined"
                        margin="normal"
                        className={classes.input}
                        placeholder={'Saint Anne Chapel, St. Tropez'}
                        InputLabelProps={{ shrink: true }}
                    />

                    <div className={classes.datepickerWrapper}>
                        <label className={classes.datepickerLabel} htmlFor={'react-date-picker-wishlist'}>
                            {t('wishlist-wizard-date-dateselect-label')}
                        </label>
                        <DatePicker
                            id={'react-date-picker-wishlist'}
                            className={classes.datepicker}
                            selected={currentSelected?.date ? new Date(currentSelected?.date) : new Date()}
                            placeholderText={'YYYY-MM-DD'}
                            showYearDropdown
                            scrollableYearDropdown
                            onChange={date => onDateChange(date)}
                        />
                    </div>

                    <Button
                        disabled={!currentSelected?.location || !currentSelected?.date}
                        fullWidth
                        className={classes.continueButton}
                        onClick={onContinue}
                    >
                        {t('wishlist-wizard-create-button')}
                    </Button>
                </>
            )}
        </Box>
    );
};